import DetailsSection from '../common/DetailsSection'
import { observer } from 'mobx-react-lite'
import AllergiesTable from 'components/common/AllergiesTable'

type AllergiesSectionProps = {
  // TODO: improve visit type
  visit: any
}

const AllergiesSection = ({ visit }: AllergiesSectionProps) => {
  const { allMemberAllergies } = visit || {}

  if (!allMemberAllergies?.length) {
    return null
  }

  return (
    <DetailsSection title="Allergies">
      <AllergiesTable allergies={allMemberAllergies} />
    </DetailsSection>
  )
}

export default observer(AllergiesSection)
